module.exports = __webpack_public_path__ + "img/46.12f88291.svg";